import { Cross } from '@components/icons'
import bidapi from 'api/bidapi'
import { AuthContext } from 'contexts/AuthContext'
import React, { Dispatch, SetStateAction, useContext } from 'react'
import { ItemCardManger } from '..'

type Props = {
  visible: boolean
  setVisible: Dispatch<SetStateAction<boolean>>
  itemId: string
  containerStyle?: string
  containerStyleObj?: any
  innerContainerStyle?: string
}

type bidIncrement = {
  startValue: number
  endValue: number
  increment: number
}

const BidIncrementModal = (props: Props) => {
  const [increments, setIncrements] = React.useState([])

  const getIncrements = async () => {
    // const result = await bidapi({
    //   method: 'GET',
    //   url: `${process.env.NEXT_PUBLIC_AUCTION_API}/bidIncrement/getItemBidIncrementByItemId/${props?.itemId}`,
    //   token: authContext?.credentials?.accessToken,
    // })

    setIncrements([])
  }

  React.useEffect(() => {
    getIncrements()
  }, [])

  return (
    <div
      className={`transition-opacity duration-200 flex justify-center items-center absolute p-4 ${
        !props?.visible ? '-z-10' : 'z-40'
      } ${!props?.visible ? ` opacity-0` : 'opacity-100'} ${
        props?.containerStyle
      }`}
      style={props?.containerStyleObj}
    >
      <div
        className={`rounded pb-2 bg-white overflow-scroll overflow-y-scroll  max-h-full ${props?.innerContainerStyle}`}
      >
        <table className="overflow-scroll align-middle content-center pl-8 ">
          <thead className="text-white bg-bidfta-green-tabledark py-1.5 ">
            <tr>
              <th className="text-md text-left pl-2 ">From ($)</th>
              <th className="text-md text-left">To ($)</th>
              <th>Increment ($)</th>
              <th
                className=" opacity-100 hover:opacity-50 transition duration-300 ease-in-out ml-2"
                onClick={(e) => {
                  e.stopPropagation()
                  props?.setVisible(false)
                }}
              >
                <Cross />
              </th>
            </tr>
          </thead>
          <tbody className="overflow-scroll">
            {increments?.length
              ? increments?.map((increment: bidIncrement, i) => {
                  const startValue = `${increment?.startValue}${
                    i === increments?.length - 1 ? '+' : ''
                  }`
                  const endValue =
                    i === increments?.length - 1 ? '' : increment?.endValue
                  return (
                    <tr
                      className={`row  ${
                        i % 2 === 0 ? 'bg-white' : 'bg-bidfta-green-tablelight'
                      }`}
                      key={i}
                    >
                      <td className=" px-2 text-md pl-2">{startValue}</td>
                      <td className=" px-2 text-md">{endValue}</td>
                      <td className=" px-2 text-md">{increment?.increment}</td>
                      <td className=" px-2 text-md"></td>
                    </tr>
                  )
                })
              : null}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default BidIncrementModal
